import socialImageSrc1 from '@images/marketing/SiteImages_Social-01.jpg';
import socialImageSrc2 from '@images/marketing/SiteImages_Social-02.jpg';
import socialImageSrc3 from '@images/marketing/SiteImages_Social-03.jpg';
export var socialContent = {
    imageData: [
        {
            src: socialImageSrc1,
            alt: 'Placeholder Image 1 from Instagram',
        },
        {
            src: socialImageSrc2,
            alt: 'Placeholder Image 2 from Instagram',
        },
        {
            src: socialImageSrc3,
            alt: 'Placeholder Image 3 from Instagram',
        },
    ],
    headline: 'We’re Social Animals',
    tickerText: '@NOMNOM',
};
